var exports = {
  "k": "x112a1f60--84f102--container",
  "w": "x112a1f60--84f102--agents-title",
};

module.exports = exports;
